<div class="container">
  <section class="rules">
    <img id="cloud" class="cloud-group_right" src="../../../assets/img/clouds/cloud-compact-group-3.svg" alt="image">
    <img class="rules-img" src="../../../assets/img/city.svg" alt="image">
    <img id="scooter" class="rules-img" src="../../../assets/img/girl.svg" alt="image">
    <div class="main-title">
      <span class="text-hover-animation">Правила и инструкции</span>
    </div>
    <div class="rules-item" (click)="rulesClick($event,  selectedRule == '1' ? '0' : '1')">
      <div class="rules-item-container">
        <div class="rules-item-title"> Как связаться со службой поддержки?</div>
        <div class="rules-item-icon-container">
          <img [ngClass]="{'rules-item-icon-cross':true, 'rules-item-icon-cross-click':selectedRule == '1'}"
               src="../../../assets/img/icon/rules-item-icon-cross.svg"
               alt="icon">
        </div>
      </div>
      <div
        [ngClass]="{'rules-item-description-container': true, 'rules-item-description-visible':selectedRule == '1','rules-item-description-hidden':selectedRule !== '1'}"
        class="rules-item-description">Зайти в приложение
        и нажать на кнопку «помощь» в правой верхней части экрана. Затем написать вопрос в
        открывшемся окне: тебе обязательно ответят.
      </div>
    </div>

    <div class="rules-item" (click)="rulesClick($event,  selectedRule == '2' ? '0' : '2')">
      <div class="rules-item-container">
        <div class="rules-item-title"> Пошаговая инструкция по аренде самоката</div>
        <div class="rules-item-icon-container">
          <img [ngClass]="{'rules-item-icon-cross':true, 'rules-item-icon-cross-click':selectedRule == '2'}"
               src="../../../assets/img/icon/rules-item-icon-cross.svg"
               alt="icon">
        </div>
      </div>
      <div
        [ngClass]="{'rules-item-description-container': true, 'rules-item-description-visible':selectedRule == '2','rules-item-description-hidden':selectedRule  !== '2'}">
        Установи приложение BusyFly для <a href="https://apps.apple.com/us/app/busyfly/id1488207086?l=ru">iOS</a> или <a
        href="https://play.google.com/store/apps/details?id=soft.gelios.com.scooter">Android</a>.
        Найди на карте самокат, забронируй его. Когда окажешься рядом с ним — отсканируй QR–code на руле.
        Зарегистрируйся. Потребуется только номер твоего телефона, почта, имя и банковская карта. Привяжи карту для
        оплаты — и вперед.
        Перед арендой осмотри самокат на видимые повреждения, если они есть – обязательно сообщи в службу поддержки.
        Выбери тариф — нажми «Начать поездку».Для начала движения – толкнись 1 ногой (минимальная скорость – 5 км/ч для
        старта) и плавно нажми ручку газа (справа)
        Для остановки отпусти ручку газа и плавно нажми ручку тормоза (слева).
      </div>
    </div>

    <div class="rules-item" (click)="rulesClick($event,  selectedRule == '3' ? '0' : '3')">
      <div class="rules-item-container">
        <div class="rules-item-title"> Как арендовать несколько самокатов на
          один аккаунт
        </div>
        <div class="rules-item-icon-container">
          <img [ngClass]="{'rules-item-icon-cross':true, 'rules-item-icon-cross-click':selectedRule == '3'}"
               src="../../../assets/img/icon/rules-item-icon-cross.svg"
               alt="icon">
        </div>
      </div>
      <div
        [ngClass]="{'rules-item-description-container': true, 'rules-item-description-visible':selectedRule == '3','rules-item-description-hidden': selectedRule !== '3'}">
        Для
        аренды нескольких (до 4) самокатов с 1 аккаунта просто нажми кнопку «забронировать еще» в окне карты и повтори
        действия, описанные выше.
      </div>
    </div>

    <div class="rules-item" (click)="rulesClick($event,  selectedRule == '4' ? '0' : '4')">
      <div class="rules-item-container">
        <div class="rules-item-title">Различные зоны на карте
        </div>
        <div class="rules-item-icon-container">
          <img [ngClass]="{'rules-item-icon-cross':true, 'rules-item-icon-cross-click':selectedRule == '4'}"
               src="../../../assets/img/icon/rules-item-icon-cross.svg"
               alt="icon">
        </div>
      </div>
      <div
        [ngClass]="{'rules-item-description-container': true, 'rules-item-description-visible':selectedRule == '4','rules-item-description-hidden': selectedRule !== '4'}">
        Зеленая зона на карте — районы города, по которым можно кататься. Здесь нельзя припарковать самокат, но можно
        поставить его на паузу. Синяя зона — места, в которых можно припарковать самокат. Красная — где кататься
        запрещено.
      </div>
    </div>

    <div class="rules-item" (click)="rulesClick($event,  selectedRule == '5' ? '0' : '5')">
      <div class="rules-item-container">
        <div class="rules-item-title"> Правила парковки
        </div>
        <div class="rules-item-icon-container">
          <img [ngClass]="{'rules-item-icon-cross':true, 'rules-item-icon-cross-click':selectedRule == '5'}"
               src="../../../assets/img/icon/rules-item-icon-cross.svg"
               alt="icon">
        </div>
      </div>
      <div
        [ngClass]="{'rules-item-description-container': true, 'rules-item-description-visible':selectedRule == '5','rules-item-description-hidden': selectedRule  !== '5'}">
        <strong>Где парковаться.</strong> Это зависит от города. В некоторых городах можно оставлять самокаты только на
        специальных
        парковках. В некоторых в любой зоне при условии, что ты не мешаешь окружающим, а самокат использованию городской
        инфраструктуре. Смотрите информацию о правилах парковки на информационных стендах или спрашивайте в службе
        поддержки. <br>
        <strong> Как парковаться.</strong> Поставь самокат на подножку или пристегни к парковке, если этого требуют
        правила в твоем
        городе. Заверши поездку.
        Отправь фотографии самоката, чтобы мы понимали, что он стоит по правилам (при отсутствии фотографий и
        неправильной парковке ты можешь быть оштрафован).
      </div>
    </div>
    <div class="rules-item" (click)="rulesClick($event,  selectedRule == '6' ? '0' : '6')">
      <div class="rules-item-container">
        <div class="rules-item-title">Проблемы с самокатом
        </div>
        <div class="rules-item-icon-container">
          <img [ngClass]="{'rules-item-icon-cross':true, 'rules-item-icon-cross-click':selectedRule == '6'}"
               src="../../../assets/img/icon/rules-item-icon-cross.svg"
               alt="icon">
        </div>
      </div>
      <div
        [ngClass]="{'rules-item-description-container': true, 'rules-item-description-visible':selectedRule == '6','rules-item-description-hidden': selectedRule  !== '6'}">

        <strong>Поломки</strong> <br>
        В случае, если на самокате есть мелкая царапина, загрязнения и т.д., которые не влияют на безопасность вождения
        — обозначь их в приложении и сфотографируй. И можно ехать.
        В случае серьезных повреждений (деформация колес или рамы самоката, не работающая ручка газа или тормоза)
        обозначь их в приложении и сфотографируй, а также сообщи номер самоката — этим ты поможешь нам вовремя заняться
        ремонтом. Затем выбирай другой самокат и можно кататься.

        Если не можешь завершить аренду, проверь, что самокат находится в разрешенной для завершения аренды зоне
        (фиолетового цвета).

        <strong> Если самокат не включается:</strong> <br>
        Убедись, что номер самоката на руле совпадает с номер самоката в приложении. Посмотри на внешний вид самоката.
        На нем должна быть надпись «BusyFly».


      </div>
    </div>
    <div class="rules-item" (click)="rulesClick($event,  selectedRule == '7' ? '0' : '7')">
      <div class="rules-item-container">
        <div class="rules-item-title"> Оплата и тарифы. Бонусные баллы
        </div>
        <div class="rules-item-icon-container">
          <img [ngClass]="{'rules-item-icon-cross':true, 'rules-item-icon-cross-click':selectedRule == '7'}"
               src="../../../assets/img/icon/rules-item-icon-cross.svg"
               alt="icon">
        </div>
      </div>
      <div
        [ngClass]="{'rules-item-description-container': true, 'rules-item-description-visible':selectedRule == '7','rules-item-description-hidden': selectedRule  !== '7'}">
        В
        BusyFly есть тарифы, стоимость минуты в которых зависит от скорости. Существуют также часовые и получасовые
        тарифы. Кроме того, в некоторых городах с пользователя берется фиксированная сумма за старт поездки. Актуальная
        стоимость катания и все возможные опции ты увидишь при нажатии на значок самоката, когда находишься в том или
        ином городе нашего присутствия.
        В некоторых городах действует система бонусов: можно единовременно положить на свой баланс в BusyFly больше
        денег (они станут внутренней валютой — коинами) и получить ощутимую скидку на поездки.
      </div>
    </div>
    <div class="rules-item" (click)="rulesClick($event,  selectedRule == '8' ? '0' : '8')">
      <div class="rules-item-container">
        <div class="rules-item-title">Как удалить аккаунт?
        </div>
        <div class="rules-item-icon-container">
          <img [ngClass]="{'rules-item-icon-cross':true, 'rules-item-icon-cross-click':selectedRule == '8'}"
               src="../../../assets/img/icon/rules-item-icon-cross.svg"
               alt="icon">
        </div>
      </div>
      <div
        [ngClass]="{'rules-item-description-container': true, 'rules-item-description-visible':selectedRule == '8','rules-item-description-hidden': selectedRule  !== '8'}">
        Чтобы удалить банковскую карту нажмите в меню «Способ оплаты», затем «изменить» возле номера вашей карты и
        нажмите на крестик. Все, карта удалена.
        Если вы хотите удалить свой аккаунт — напишите в поддержку (кнопка «Помощь» на главном экране)
      </div>
    </div>
  </section>
</div>
